import { roundNumber } from '@common/methods/roundNumber/roundNumber';
import { PERFORMANCE_ELEMENT_ID } from '../components/PERFORMANCE_ELEMENT_ID';

const MAXIMUM_TIME_FRAME = roundNumber(1000 / 30, 0); // 30 FPS
const MAX_SLOW = 10;
const LOW_PERFORMANCE_LOAD_THRESHOLD = 250;

let DRAW_LOAD = 1;
let SLOW_COUNT = 0;

const draw = function (load, ctx) {
	const img = document.querySelector('img');
	const angle = 0.01;
	ctx.clearRect(0, 0, 400, 400);
	ctx.save();
	ctx.translate(200, 200);
	for (let i = 0; i < load; i++) {
		ctx.rotate(angle);
		if (img) {
			ctx.drawImage(img, 0, 0);
		}
	}
	ctx.restore();
};

const tick = function (ctx, callback, previousTime = null) {
	const t_ = performance.now();
	const elapsed_ = previousTime ? t_ - previousTime : 0;
	const previousTime_ = t_;
	if (elapsed_ < MAXIMUM_TIME_FRAME || SLOW_COUNT < MAX_SLOW) {
		if (elapsed_ < MAXIMUM_TIME_FRAME) {
			DRAW_LOAD += 10;
		} else {
			SLOW_COUNT++;
		}
		draw(DRAW_LOAD, ctx);
		requestAnimationFrame(() => tick(ctx, callback, previousTime_));
	} else {
		// found maximum sustainable load at 30 FPS
		// alert(`could draw ${DRAW_LOAD} in ${MAXIMUM_TIME_FRAME} ms`);
		callback(DRAW_LOAD < LOW_PERFORMANCE_LOAD_THRESHOLD);
	}
};

type CheckLowPerformanceCalback = (isLow: boolean) => void;

export const checkLowPerformance = (callback: CheckLowPerformanceCalback) => {
	const performanceBox = document.getElementById(PERFORMANCE_ELEMENT_ID);
	const canvas = document.createElement('canvas');
	performanceBox.appendChild(canvas);
	const ctx = canvas.getContext('2d');
	requestAnimationFrame(() => tick(ctx, callback));
};
